
import React, { createRef, useEffect, useState } from "react";
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import './_css/index.css';
import "perfect-scrollbar/css/perfect-scrollbar.css";
import { Routes, Route, Link, Navigate } from "react-router-dom";

// Keep core pages as normal imports for instant access
import Login from './login';
import Home from './home';

// Lazy-load admin manage page for code splitting
const Manage = React.lazy(() => import('./View/admin/main/index'));

import Hidden from '@mui/material/Hidden';
import {
    drawerWidth,
    appbarHeight
} from "./assets/jss/psstyle/psacount";
import AccountMenu from './Components/Navbars/Acountmenu';
import parseJwt from "./CustomFunction/parseJWT.js";
import Logout from "./CustomFunction/User/logout"
import { styled, useTheme } from '@mui/material/styles';
import styles from "./assets/jss/psstyle/component/headerStyle"
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import CssBaseline from '@mui/material/CssBaseline';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import Adminslidbar from "./Components/Slidebar/Adminslidbar";
import { genURL, genURLWithAuth, getDataWithAuth } from "./_getjson";
import axios from "axios";
// const drawerWidth = 320;
const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
        flexGrow: 1,
        padding: theme.spacing(0),
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        marginLeft: `-${drawerWidth}px`,
        ...(open && {
            transition: theme.transitions.create('margin', {
                easing: theme.transitions.easing.easeOut,
                duration: theme.transitions.duration.enteringScreen,
            }),
            marginLeft: 0,
        }),
        width: `calc(100% - ${drawerWidth}px)`,
        height: "100vh",
        overflowY: "auto"
    }),
);
const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
    transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: `${drawerWidth}px`,
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
    }),
    height: appbarHeight,
    ...styles.appBar,
    display: "flex"
}));
const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: 'flex-end',
    height: appbarHeight,
    ...styles.DrawerHeader,
}));
//   page  
// Loading fallback component for lazy-loaded routes
const PageLoader = () => (
    <Box sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: '#f5f5f5'
    }}>
        <div style={{ textAlign: 'center' }}>
            <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem' }}>
                <span className="sr-only">Loading...</span>
            </div>
            <p style={{ marginTop: '1rem', color: '#666' }}>กำลังโหลด...</p>
        </div>
    </Box>
);

// RouterPath must contain only <Route> elements (no Suspense wrapper here)
var RouterPath;
if (!localStorage.getItem("Token")) {
    RouterPath = <Route path="/login" component={Login} />
} else {
    var RouterPath = (
        <>
            <Route index path="/home" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path='/manage' element={<Manage />} />
            <Route path="*" element={<NoMatch />} />
        </>
    )
}
async function NoMatch() {
    console.log("localStoragegetItemToken", localStorage.getItem('Token'))
    if (localStorage.getItem('Token')) {
        let datenow = Math.round((new Date()).getTime() / 1000)
        let dateExp = parseJwt(localStorage.getItem('Token')).exp
        console.log("localStoragegetItemToken ", dateExp);
        console.log("localStoragegetItemToken datenow", datenow);
        if (datenow > dateExp) {
            Logout()
            // window.location.href = '/login'
        } else {
            window.location.href = '/home'
        }
    } else {
        console.log("else");
        Logout()
        //window.location.href = '/login'
    }
}
export default function adminlayout({ ...rest }) {
    const theme = useTheme();
    // styles
    const [open, setOpen] = React.useState(false);
    const [openToggle, setOpenToggle] = React.useState(false);
    const [categoryreport, setCategoryreport] = React.useState([]);
    React.useEffect(() => {
        // Update the document title using the browser API
        checkOpenToggle()
        getCategory()
        return () => { };
    }, []);
    const getCategory = async () => {
        let url = "reportmanage/category?filter=active"
        let elementcategory = []
        const fullURL = genURLWithAuth(url);
        const res = await getDataWithAuth(fullURL);
        
        if (res && res !== "error" && res.data && res.data.length > 0) {
            for (let index = 0; index < res.data.length; index++) {
                if (res.data[index].catelevel == 0) {
                    elementcategory.push(res.data[index])
                }
            }
        }
        
        console.log("elementcategory", elementcategory)
        setCategoryreport(elementcategory)
    }
    const checkOpenToggle = () => {
        console.log("checkOpenToggle", localStorage.getItem("OpenToggle"));
        if (localStorage.getItem("OpenToggle") === "false") {
            setOpen(false)
        } else {
            setOpen(false)
        }
    }
    const toggleDrawer = (open) => (event) => {
        setOpen(open)
        // localStorage.setItem("OpenToggle", open)
        // console.log("OpenToggle toggleDrawer", open);
    };
    const handleDrawerOpen = () => {
        setOpen(true);
        localStorage.setItem("OpenToggle", "true")
        console.log("OpenToggle handleDrawerOpen");
    };
    const handleDrawerClose = () => {
        setOpen(false);
        localStorage.setItem("OpenToggle", "false")
        console.log("OpenToggle handleDrawerClose");
    };
    const handleDrawerToggle = () => {
        setOpenToggle(!openToggle)
        console.log("OpenToggle handleDrawerToggle");
    };

    return (
        <>
            <Box sx={{ display: 'flex', flexGrow: 1 }}>
                <CssBaseline />
                <AppBar position="static" open={open}  >
                    <Toolbar>
                        {localStorage.getItem("Token") !== null ?
                            <>
                                <Box component="div" sx={{ flexGrow: 1 }}>
                                    {/* <IconButton
                                        color="inherit"
                                        aria-label="open drawer"
                                        onClick={handleDrawerOpen}
                                        edge="start"
                                        sx={{ mr: 2, ...(open && { display: 'none' }) }}
                                    >
                                        <MenuIcon />
                                    </IconButton> */}
                                </Box>
                                <Box>
                                    <Hidden mdDown implementation="css">
                                        <AccountMenu categoryReport={categoryreport} />
                                    </Hidden>
                                    <Hidden mdUp implementation="css">
                                        <IconButton
                                            color="inherit"
                                            aria-label="open drawer"
                                            onClick={handleDrawerToggle}
                                        >
                                            {/* <AccountMenu /> */}
                                            <MenuIcon />
                                        </IconButton>
                                    </Hidden>
                                </Box>
                            </> : ""}

                    </Toolbar>
                </AppBar>
                <Drawer
                    sx={{
                        width: drawerWidth,
                        flexShrink: 0,
                        '& .MuiDrawer-paper': {
                            width: drawerWidth,
                            boxSizing: 'border-box',
                            overflowY: 'hidden',
                            overflowX: 'hidden',
                            display: 'flex'
                        },

                    }}
                    variant="persistent"
                    anchor="left"
                    open={open}
                >
                    <DrawerHeader>
                        <IconButton onClick={handleDrawerClose}>
                            {theme.direction === 'ltr' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
                        </IconButton>
                    </DrawerHeader>
                    <Divider />
                    {/* <Adminslidbar /> */}
                </Drawer>
                {/* end Drawer left */}

                <Main open={open}>
                    <DrawerHeader />
                    <React.Suspense fallback={<PageLoader />}>
                        <Routes>
                            {RouterPath}
                        </Routes>
                    </React.Suspense>
                </Main>
            </Box >
            <div>
                <React.Fragment key={"top"}>
                    <SwipeableDrawer
                        anchor={"top"}
                        open={openToggle}
                        onClose={toggleDrawer(false)}
                        onOpen={toggleDrawer(true)}
                    >
                        <Box sx={{ ...styles.SwipeableDrawer }}>
                            <AccountMenu categoryReport={categoryreport} />
                        </Box>
                    </SwipeableDrawer>
                </React.Fragment>

            </div>

        </>
    )
}